import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ApiRequest from 'core/api/request';
import { trackEvent } from 'core/utils';

import {
	ItemDescriptionContainer,
	LinkStyle,
	DeleteItemStyle,
	Name,
	DeleteCircle,
} from './shopBagItemStyles';

class ItemDescription extends PureComponent {
	static propTypes = {
		name: PropTypes.string.isRequired,
		cartProductId: PropTypes.number.isRequired,
		productId: PropTypes.number.isRequired,
		productInstanceId: PropTypes.number.isRequired,
		subscriptionTypeTermId: PropTypes.number,
		remove: PropTypes.func.isRequired,
		href: PropTypes.string.isRequired,
	};

	onDelete = async () => {
		const {
			productId,
			productInstanceId,
			subscriptionTypeTermId,
		} = this.props;
		try {
			await ApiRequest.delete(`/cart_products/${this.props.cartProductId}/`);
			this.props.remove();

			const variant = subscriptionTypeTermId ? productInstanceId + '_' + subscriptionTypeTermId : productInstanceId;
			trackEvent("remove_from_cart", {
				braze: [{
					listingId: productId,
					variant: variant,
					productInstanceId,
					subscriptionTypeTermId,
					quantity: 1,
				}],
			});
		} catch (error) {
			console.log(error);
		}
	};

	trimName = name => {
		const MAX_CHARS = 45;
		const nameLength = name.length;
		return nameLength <= MAX_CHARS
			? name
			: name.split('').splice(0, MAX_CHARS).join('') + '...'
		;
	};

	render() {
		return (
			<ItemDescriptionContainer>
				<LinkStyle href={this.props.href}>
					<Name>{this.trimName(this.props.name)}</Name>
				</LinkStyle>
				<DeleteItemStyle onClick={this.onDelete}>
					<DeleteCircle/>
					<div>Remove</div>
				</DeleteItemStyle>
			</ItemDescriptionContainer>
		);
	}
}

export default ItemDescription;
